import { render, staticRenderFns } from "./DragResize.vue?vue&type=template&id=44840e13&scoped=true"
import script from "./DragResize.vue?vue&type=script&lang=js"
export * from "./DragResize.vue?vue&type=script&lang=js"
import style0 from "./DragResize.vue?vue&type=style&index=0&id=44840e13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44840e13",
  null
  
)

export default component.exports